// 27KH #109219 add
import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { initialValues } from 'pages/MCBMS010/formConfig'
import { MCBMS010CreateRequest } from "types/MCBMS010/MCBMS010CreateRequest"

export interface LoginPermissionIpAddressCreate {
loginPermissionIpAddressSetting: string,
loginPermissionIpAddressV6Setting: string,
// 27KH #11085 start
companySysVersionNumber: string,
// 27KH #11085 end
}

interface LoginPermissionIpAddress {
  loginPermissionIpAddressCreate: LoginPermissionIpAddressCreate
  // 27KH #11020 Start
  isLoading: boolean
  // 27KH #11020 End
}

const initialState: LoginPermissionIpAddress = {
  // 27KH #11020 Start
  loginPermissionIpAddressCreate:initialValues,
  isLoading: true
  // 27KH #11020 End
}
const loginPermissionIpAddressSlice = createSlice({
  name: 'loginPermitIpAddres',
  initialState,
  reducers:{
    setIpAddressCreate(state, action: PayloadAction<MCBMS010CreateRequest>) {
      return state
    },
    getloginPermissionIpAddressDetail(state) {
      return state
    },
    setloginPermissionIpAddressDetail(state, action: PayloadAction<MCBMS010CreateRequest>){
      state.loginPermissionIpAddressCreate = action.payload
      return state
    },
    // 27KH #11020 Start
    startLoading(state) {
      state.isLoading = true;
    },
    finishLoading(state) {
      state.isLoading = false;
    },
    // 27KH #11020 End
  },
})

const { actions, reducer } = loginPermissionIpAddressSlice

export const {
  setIpAddressCreate,
  getloginPermissionIpAddressDetail,
  setloginPermissionIpAddressDetail,
  // 27KH #11020 Start
  startLoading,
  finishLoading,
  // 27KH #11020 End
} = actions
export default reducer